import { useMemo } from 'react';

import { useEntitiesSalesOrdersByFulfillmentPlanId } from '../../hooks/entities/selectors/sales-orders';
import { MarketplaceIds } from '../../enums/marketplace-ids';

export const useIsTikTokShippingOrder = (fulfillmentPlanId) => {
  const salesOrders = useEntitiesSalesOrdersByFulfillmentPlanId(fulfillmentPlanId);

  return useMemo(() => {
    if (!salesOrders?.length) {
      return false;
    }
    return salesOrders.some((order) => Number(order?.store?.marketplaceId) === MarketplaceIds.TikTok);
  }, [salesOrders]);
};
